import React, { useEffect, useState } from 'react';
import strings from './strings';

// Tap-to-edit BPM. Same contract as the desktop TempoInput in ScoreDisplay:
// holds a draft while typing and commits on Enter or blur so a half-typed
// value is never applied as a tempo.
const TempoField = ({ value, onCommit }) => {
  const [draft, setDraft] = useState(String(value));
  const [isEditing, setIsEditing] = useState(false);

  useEffect(() => {
    if (!isEditing) setDraft(String(value));
  }, [value, isEditing]);

  const commit = () => {
    setIsEditing(false);
    const parsed = parseInt(draft, 10);
    if (Number.isFinite(parsed) && parsed !== value) {
      onCommit(parsed);
    } else {
      setDraft(String(value));
    }
  };

  return (
    <input
      type="number"
      inputMode="numeric"
      min={20}
      max={400}
      className="mps-tempo-field"
      aria-label={strings.bpm}
      value={draft}
      onFocus={(e) => { setIsEditing(true); e.target.select(); }}
      onChange={(e) => setDraft(e.target.value)}
      onBlur={commit}
      onKeyDown={(e) => {
        if (e.key === 'Enter') {
          e.preventDefault();
          e.target.blur();
        } else if (e.key === 'Escape') {
          setDraft(String(value));
          setIsEditing(false);
          e.target.blur();
        }
        e.stopPropagation();
      }}
    />
  );
};

export default TempoField;
